import React from "react";

export const InputGroupAddon = ({ children }) => (
  <div className="input-group-addon">{children}</div>
);

export const InputGroup = ({ children }) => {
  return <div className="input-group">{children}</div>;
};
